import { Record } from "immutable";

export const routerLocationFromJSON = (locationData: Partial<IRouterLocationData>): RouterLocationRecord => {
  const recordData: IRouterLocationRecord = { ...(locationData as any) };

  return new RouterLocationRecord(recordData);
};

export interface IRouterLocationData {
  pathname: string;
  search: string;
  hash: string;
  key: string;
  query: any;
}

export interface IRouterLocationRecord {
  pathname: string;
  search: string;
  hash: string;
  key: string;
  query: any;
}

export const defaultRouterLocationProps = {
  pathname: "",
  search: "",
  hash: "",
  key: "",
  query: {},
};

export class RouterLocationRecord
  extends Record<IRouterLocationRecord>(defaultRouterLocationProps)
  implements IRouterLocationRecord {}
